<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13OTQiO/tc-custom/9780674268456.jpg?1724089333951" alt="This image is the cover for the book Lost Children"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Children
      </h1>
      <p class="bookDescription body article font2">
        <b>“This impressive . . . study charts the history of [post WWII] humanitarian relief . . . demonstrating how the institutions of the family became politicized.” (<i>Library Journal)</i></b><br/>  <br/> During the Second World War, an unprecedented number of families were torn apart. As the Nazi empire crumbled, millions roamed the continent in search of their loved ones. <i>The Lost Children</i> tells the story of these families. We see how the reconstruction of families quickly became synonymous with the survival of European civilization itself.<br/>  <br/> Based on original research in German, French, Czech, Polish, and American archives, <i>The Lost Children</i> is a heartbreaking and mesmerizing story. It brings together the histories of eastern and western Europe, and traces the efforts of everyone―from Jewish Holocaust survivors to German refugees, from Communist officials to American social workers―to rebuild the lives of displaced children. It reveals that many seemingly timeless ideals of the family were actually conceived in the concentration camps, orphanages, and refugee camps of the Second World War, and shows how the process of reconstruction shaped Cold War ideologies and ideas about childhood and national identity. This riveting tale of families destroyed by war reverberates in the lost children of today’s wars and in the compelling issues of international adoption, human rights and humanitarianism, and refugee policies.<br/>  <br/> “Fascinating.” ―<i>New Republic</i><br/>  <br/> “[A] superb book . . . [A] wide-ranging, exceptionally well-researched study.” ―<i>Tablet Magazine</i><br/>  <br/> “Zahra’s work is insightful in considering what treatment of lost children can tell us about broader developments in the post-war period, both in terms of how nations interacted with each other and how psychologists understood the impact of war on children.” —<i>Times Higher Education</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tara Zahra
      </h2>
      
      <p class="authorDescription body article">Tara Zahra is Assistant Professor of History at the University of Chicago.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harvard University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35dc870a